import {Injectable} from '@angular/core';
import {TranslationService} from './translation.service';

declare interface IFormattingInfo {
  currencySymbol: string;
  decimalSeparator: string;
  thousandsSeparator: string;
}

@Injectable()
export class FormattingService {
  public constructor(private _translationService: TranslationService) {
  }

  public formatCurrencyDefault(value: number, decimals?: number): string {
    const formatInfo = this._getCurrentFormattingInfo();
    return `${this._formatNumber(value, decimals, 3, formatInfo)} ${formatInfo.currencySymbol}`;
  }

  public formatProzentDefault(value: number, decimals?: number): string {
    const formatInfo = this._getCurrentFormattingInfo();
   return `${this._formatNumber(value, decimals, 3, formatInfo)}%`;
  }

  private _formatNumber(number: number, decimals: number, whole: number, formatInfo: IFormattingInfo): string {
    if (typeof decimals === 'undefined') {
      decimals = 2;
    }

    const re = '\\d(?=(\\d{' + (whole || 3) + '})+' + (decimals > 0 ? '\\D' : '$') + ')';
    const num = number.toFixed(Math.max(0, decimals));

    return num
      .replace('.', (formatInfo.decimalSeparator || '.'))
      .replace(new RegExp(re, 'g'), '$&' + (formatInfo.thousandsSeparator || ','));
  }

  private _getCurrentFormattingInfo(): IFormattingInfo {
    return {currencySymbol: '€', decimalSeparator: ',', thousandsSeparator: '.'};
  }

}
